import { useState, useRef, useCallback, useEffect } from 'react';
import { INPUT_MAX_HEIGHT_PX } from '../constants';

export function useChatInput(isLoading, onSend) {
  const [inputMessage, setInputMessage] = useState('');
  const inputRef = useRef(null);

  const resizeInput = useCallback(() => {
    const el = inputRef.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${Math.min(el.scrollHeight, INPUT_MAX_HEIGHT_PX)}px`;
  }, []);

  useEffect(() => {
    resizeInput();
  }, [inputMessage, resizeInput]);

  const clearInput = useCallback(() => {
    setInputMessage('');
  }, []);

  const submitMessage = useCallback(() => {
    const text = inputMessage.trim();
    if (!text || isLoading) return;
    onSend(text);
    setInputMessage('');
  }, [inputMessage, isLoading, onSend]);

  const handleSend = useCallback(
    (e) => {
      e.preventDefault();
      submitMessage();
    },
    [submitMessage]
  );

  const handleInputKeyDown = useCallback(
    (e) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        submitMessage();
      }
    },
    [submitMessage]
  );

  const canSend = !isLoading && inputMessage.trim().length > 0;

  return {
    inputMessage,
    setInputMessage,
    inputRef,
    handleSend,
    handleInputKeyDown,
    canSend,
    clearInput,
    focusInput: () => inputRef.current?.focus()
  };
}
